import type { CountryConfig } from "./types";

export const dkConfig: CountryConfig = {
  code: "dk",
  locale: "da",
  numberLocale: "da-DK",
  dateFormat: "dd.MM.yyyy",
  dateFormatRegex: /\d{2}\.\d{2}\.\d{4}/,
  dateSeparator: ".",
  decimalSeparator: ",",
  currency: "DKK",
  hoursPerDay: 7.4,
  hoursPerWeek: 37,
  availableLocales: [],
  features: {
    salary: true,
    absenceApproval: true,
    sixthWeekDayOff: true,
    messageCenter: true,
    configurableSoCalculation: true,
    employmentEditing: true,
    employmentStatement: true,
    agreementField: true,
    employmentRateAsPercent: false,
    grossTime: true,
    closedDaysInWeekTargetSetting: true,
    poolPlanning: false,
    departmentManagement: true,
    personalDataEditing: true,
    institutionMasterDataEditing: true,
    departmentMasterDataEditing: true,
    endDateConfirmation: false,
    departmentStaffingGraphs: false,
    staffingOverview: false
  },
  terminology: {
    employmentRate: "employmentOverview.rateOfEmployment",
    appName: "app.name"
  },
  support: {
    email: "grundskole@ist.dk",
    phone: "70 21 21 30"
  }
};
